import { useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Context } from '@entities/Context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faPlusCircle } from '@fortawesome/free-solid-svg-icons'

export default function Welcome() {
    const { storage } = useContext(Context)
    const navigate = useNavigate()
    const email = import.meta.env.VITE_MAIL_FROM_ADDRESS || ''
    const video = import.meta.env.VITE_VIDEO_URL || '#'

    useEffect(() => {
        if (storage.get('pin')) {
            storage.reset()
            navigate('/login')
        }
    }, [])

    return (
        <div>
            <p className="mb-6 text-lg font-light">
                Welcome to the <strong className="font-bold">online giving portal for New Heights
                Baptist Church.</strong> You can use this secure portal to make contributions.
                Watch the <a className="font-bold underline text-primary hover:cursor-pointer" href={video} target="_blank" rel="noreferrer">Instructional Video</a>
                {' '}to get started. If you have any questions or need assistance please contact
                <a href={`mailto:${email}`} className="font-bold underline text-primary hover:cursor-pointer">{` ${email}`}</a>.
            </p>
            <div className="flex flex-wrap -mx-4">
                <div className="w-full px-4 mb-6 md:w-1/2 md:mb-0">
                    <h1 className="mb-4 text-3xl">Getting Started</h1>
                    <p className="mb-6 font-light">
                        Getting started with online giving just requires creating an account with a PIN
                        to keep your giving records secure. You will then be able to sign in to your
                        account next time which will save you time making contributions.
                    </p>
                    <button onClick={() => navigate('/register')} className="px-6 py-3 font-bold text-white rounded cursor-pointer bg-primary" type="button">
                        <FontAwesomeIcon icon={faPlusCircle} className="mr-3 fa-lg"/>
                        Create Account
                    </button>
                </div>
                <div className="w-full px-4 md:w-1/2">
                    <h1 className="mb-4 text-3xl">Member Login</h1>
                    <p className="mb-6 font-light">
                        If you have already setup an account for online giving then you just need to
                        sign in to your account to pull up your giving records and make additional
                        contributions.
                    </p>
                    <button onClick={() => navigate('/login')} className="px-6 py-3 font-bold text-white rounded cursor-pointer bg-primary" type="button">
                        Sign In
                        <FontAwesomeIcon icon={faArrowRight} className="ml-3 fas fa-lg" />
                    </button>
                </div>
            </div>
        </div>
    )
}
